import {
  pageMoveAnkerFunc,
} from "./common/_pageLinkAnimation";
import {
  idxFunc,
} from "./pages/_index";
import {
  fadeInFunc,
} from "./common/_common";
//* ----------------------------------------
//window実行
//--------------------------------------- */
////// ロード時
$(window).on('load', function () {
  idxFunc();
  fadeInFunc();
  pageMoveAnkerFunc();
});